import { render, staticRenderFns } from "./ViewPlate.vue?vue&type=template&id=27bbd317&"
import script from "./ViewPlate.vue?vue&type=script&lang=js&"
export * from "./ViewPlate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports